import { Image as AntImage } from "antd";
import React, { useState } from "react";

import styled from "styled-components";

import * as Layout from "~/Layout";
import * as Typography from "~/Typography";

export * as Action from "../../Action";
export * as Thumbnail from "../Thumbnail";

export type ImageSizeProps = {
  readonly width?: string;
  readonly height?: string;
};

type ImageProps = ImageSizeProps & {
  readonly imageUrl: string;
};

export function Image({ imageUrl, width, height }: ImageProps) {
  const [isError, setError] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);

  const onError = () => {
    setError(true);
  };

  const containerHeight = height ?? "50vh";

  return (
    <Layout.Flex.Component row align="flex-end">
      {isError ? (
        <NotFound size={300} />
      ) : (
        <ImageContainer data-testid="image-carousel-image" height={containerHeight}>
          <AntImage
            src={imageUrl}
            onError={onError}
            {...{ width, height }}
            preview={{
              visible: previewVisible,
              onVisibleChange: setPreviewVisible,
            }}
          />
        </ImageContainer>
      )}
    </Layout.Flex.Component>
  );
}

const ImageContainer = styled.div<ImageSizeProps>`
  max-height: ${({ height }) => height};
`;

export type NotFoundProps = {
  readonly size: number;
};

export const NotFound: React.Fn<NotFoundProps> = ({ size }) => (
  <Layout.Flex.Component bordered style={{ width: size, height: size }}>
    <Typography.Component jumbo>Image not found</Typography.Component>
  </Layout.Flex.Component>
);
